const HERO_IMAGE = '/assets/loginBackground.png';

export default (theme: Object) => ({
  root: {
    minHeight: '100vh',
    display: 'flex',
    flexDirection: 'column',
    position: 'relative',
    backgroundImage: `url(${HERO_IMAGE})`,
    backgroundSize: 'cover',
    backgroundPosition: 'center right',
    fontFamily: 'Work Sans, Helvetica, Arial, sans-serif',
  },
  overlay: {
    position: 'fixed',
    inset: 0,
    background: 'linear-gradient(100deg, rgba(10,26,60,0.85) 0%, rgba(15,98,189,0.68) 55%, rgba(15,98,189,0.18) 100%)',
    zIndex: 0,
  },
  navSignIn: {
    textTransform: 'none',
    fontWeight: 600,
    fontSize: '0.875rem',
    color: '#fff',
    borderColor: 'rgba(255,255,255,0.55)',
    '&:hover': {
      borderColor: '#fff',
      backgroundColor: 'rgba(255,255,255,0.1)',
    },
  },
  body: {
    position: 'relative',
    zIndex: 1,
    flex: 1,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '100px 24px 48px',
    [theme.breakpoints.down('sm')]: {
      alignItems: 'flex-start',
      padding: '88px 16px 32px',
    },
  },
  card: {
    backgroundColor: '#fff',
    borderRadius: 12,
    boxShadow: '0 20px 60px rgba(10,26,60,0.35)',
    padding: '40px 40px 36px',
    width: '100%',
    maxWidth: 480,
    [theme.breakpoints.down('xs')]: {
      padding: '32px 24px 28px',
    },
  },
  cardLogo: {
    marginBottom: 24,
    display: 'flex',
    justifyContent: 'center',
    '& svg': {
      height: 36,
      width: 'auto',
    },
  },
});
